module.exports = __webpack_public_path__ + "img/post-thumb-1.bd80cf74.jpg";